<template>
  <div class="homeBox">
    <!--    banner     -->
    <div class="banner PurchaseBanner">
      <img src="../../public/img/epbg.png" alt="">
      <div class="softScript PurchaseSoftScript">
        <div class="TipText">
          <div class="title">企业面板</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            管理层可以有效的了解一些数据的统计（包括客户统计、报价统计、<br>销售合同统计、项目统计）。
            还有一些项目当前所处在的阶段。公司<br>有哪些重要的企业客户、销售合同及查看销售报价情况，
            付了哪些<br>款项，还有哪些未收款项并了解每个员工的工作计划和工作进度
          </div>
          <div class="start">
            <a href="javascript:;" onclick="window.open('http://www.teamrobotics.net/project')">
              开始吧
              <img src="../../public/img/right.png" alt="">
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="SolveQuestion PurchaseQuestion">
      <div class="w1200">
        <div class="clearfix Sales">
          <div class="l">
            <img src="../../public/img/ep1.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/epicon1.png" alt="">
            </div>
            <div class="tip">
              企业总览
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      客户统计：客户池总数、客户池期间新增总
                      数、历史成交客户总数、期间成交客户总数;
                    </div>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      报价统计：历史报价总数、期间新增报价数;
                    </div>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      销售合同统计：按人员统计、按时间统计;
                      项目统计：项目总数「前期项目、实施中项
                      目、维保中项目，新立项/新启动」。分析
                      结果多维度全面呈现多图表、可视化，大数
                      据助力洞察让战略制定更精准，高层决策更
                      准确
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="clearfix Progress">
          <div class="l">
            <img src="../../public/img/ep2.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/epicon2.png" alt="">
            </div>
            <div class="tip">
              企业项目
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      安排并透视团队每位执行成员的负责或参与
                      的项目，近期的项目是否有效、进度是否合
                      理、与其他同事的配合协作是否及时、是否
                      能够顺利完成任务，通过关注企业项目，让
                      你自由掌握，第一时间推进重要事情
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="clearfix Purchase">
          <div class="l">
            <img src="../../public/img/ep3.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/epicon3.png" alt="">
            </div>
            <div class="tip">
              企业客户
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      帮助高层管理者掌握团队所有客户联系明细、
                      实现客户从一般、优质、意向、到成功的全
                      过程跟踪，形成好的销售经验再复制
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="clearfix Progress GetMetarial">
          <div class="l">
            <img src="../../public/img/ep4.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/epicon4.png" alt="">
            </div>
            <div class="tip">
              销售合同
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      每笔销售订单都是公司的重要机密信息，更
                      需要规范化安全的管理；
                    </div>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      从立项、订单审批、回款、开票，业务交易
                      流程全程管理
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="clearfix Purchase">
          <div class="l">
            <img src="../../public/img/ep5.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/epicon5.png" alt="">
            </div>
            <div class="tip">
              销售报价
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      流程化的报价管理，改善以往上级一对一商
                      定的方式
                    </div>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      轻松调取查看历史价格数据
                    </div>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      客户、供应商、等多种类型的订单价格集中
                      管理
                    </div>
                  </a>
                </li>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      多产品价格，打包管理，便捷有序
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="clearfix Progress GetMetarial">
          <div class="l">
            <img src="../../public/img/ep6.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/epicon6.png" alt="">
            </div>
            <div class="tip">
              计划收款
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      通过制定收款计划，帮助企业项目合理规划
                      资金往来，自动完成对未来某一时点或周期
                      性的收款业务。
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="clearfix Purchase">
          <div class="l">
            <img src="../../public/img/ep7.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/epicon7.png" alt="">
            </div>
            <div class="tip">
              计划付款
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      支持分期计划回款，清晰记录回款及账期，
                      规范管理企业的现金流和应收账款，保障业
                      绩准确、真实、有效
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="clearfix Progress GetMetarial">
          <div class="l">
            <img src="../../public/img/ep8.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/epicon8.png" alt="">
            </div>
            <div class="tip">
              工作计划
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      无论年度计划、周月计划、项目计划…都能
                      轻松搞定。每一个任务，你都能编写详情、
                      上传附件、随时
                      讨论，工作进展一目了然。每个人都知道他
                      该做什么、为什么做。
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="clearfix Purchase">
          <div class="l">
            <img src="../../public/img/ep9.png" alt="">
          </div>
          <div class="r">
            <div class="icon">
              <img src="../../public/img/epicon9.png" alt="">
            </div>
            <div class="tip">
              工作汇报
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="javascript:;">
                    <div>
                      <span class="triangle-right"></span>
                      执行人员每天写日报，汇报工作，反映问题，
                      制定工作计划
                      管理层每天看日报，团队工作一目了然，下
                      属状况尽在掌握
                      考核日报，管理层对执行人员每日工作成效
                      进行打分
                    </div>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--提高效率，提高竞争力-->
    <div class="Increase PurchaseIncrease">
      <div class="w1200">
        <div class="TipText">
          <div class="title">提高效率，提高竞争力</div>
          <div class="line">
            <span class="blue"></span>
            <span class="yellow"></span>
            <span class="green"></span>
          </div>
          <div class="script">
            让每个自动化企业都享受智慧服务与数据
            带来的改变
            <div class="bottomStart"><a href="javascript:;" onclick="window.open('http://www.teamrobotics.net/project')">开始吧<img src="../../public/img/right.png" alt=""></a></div>
          </div>
        </div>
      </div>
    </div>
    <!--导航  pc+mobile-->
    <Nav></Nav>
    <!--底部-->
    <Foot></Foot>
    <!--返回头部-->
    <GoTop></GoTop>
  </div>
</template>
<script>
  import Nav from '@/components/Nav.vue'
  import GoTop from '@/components/GoTop.vue'
  import Foot from '@/components/Foot.vue'
  export default {
    name: 'CompanyPanel',
    data(){
      return {

      }
    },
    components: {
      Nav,
      GoTop,
      Foot
    },
    computed:{

    },
    methods:{

    },
    mounted(){

    },
    activated(){

    },
    created(){

    }
  }
</script>
<style>

</style>
